import { useMutation } from "@tanstack/react-query";
import TenantHandler from "../handlers/tenant";

const useGetPartnersCustomerDetail = (onSuccess, onFailure) => {
    const tenantHandler = new TenantHandler();

    const { data, isPending, isSuccess, isError, error, mutate } = useMutation({
        mutationFn: (payload) => tenantHandler.getPartnerCustomerDetail(payload),
        mutationKey: ["get_partners_customer_detail"],
        onSuccess: onSuccess,
        onError: onFailure,
    });

    return { data, isPending, isSuccess, isError, error, mutate };
};

export default useGetPartnersCustomerDetail;
